const LOCAL_NODE_BACKEND_HOST = "http://89.150.143.125:3010";
const LOCAL_PHP_BACKEND_HOST = "http://89.150.143.125";

const LIVE_NODE_BACKEND_HOST = "https://api.gardensketcher.com";
const LIVE_PHP_BACKEND_HOST = "https://gardensketcher.com";

const isLocal = () => {
  return !window.location.hostname.includes("gardensketcher");
};

const getPhpBackendHost = () => {
  if (isLocal()) {
    console.log("Using backend host:", LOCAL_PHP_BACKEND_HOST);
    return LOCAL_PHP_BACKEND_HOST;
  } else {
    console.log("Using backend host:", LIVE_PHP_BACKEND_HOST);
    return LIVE_PHP_BACKEND_HOST;
  }
};

const getNodeBackendHost = () => {
  if (isLocal()) {
    console.log("Using AI backend host:", LOCAL_NODE_BACKEND_HOST);
    return LOCAL_NODE_BACKEND_HOST;
  } else {
    console.log("Using AI backend host:", LIVE_NODE_BACKEND_HOST);
    return LIVE_NODE_BACKEND_HOST;
  }
};

export const BackendSelector = {
  getPhpBackendHost,
  getNodeBackendHost,
};
